const strings = {
  infoFarmer: 'Dados do agricultor',
}

export default strings
